import { render, staticRenderFns } from "./PayService.vue?vue&type=template&id=624f689c"
import script from "./PayService.vue?vue&type=script&lang=ts"
export * from "./PayService.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports